module.exports = fox => {
    'use strict';

    return () => {
        const joinOptions = fox.getEnv('siteProps.ubs.joinOptions.options') || [];

        return joinOptions.reduce((acc, option) => {
            const discount = fox.objectGet(option, 'discountParams.discount');
            
            return acc = parseFloat(discount && discount > acc ? discount : acc);
        }, 0);
    }
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/common/getMaxDiscount.es.js